import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { Navbar } from './components/Navbar';
import { CommandPalette } from './components/CommandPalette';
import { SocketProvider } from 'providers/SocketProvider';
import storage from 'utils/storage';
import { useTheme } from 'hooks/useTheme';


export const MainLayout = ({ children }) => {
  const token = storage.getToken();
  const { theme, background } = useTheme();
  const [mode, setMode] = useState('admin'); // Mode can still be separate (admin/developer/vault)

  const getModeOverlay = () => {
    switch (mode) {
      case 'developer':
        return 'bg-[#1F2F16]/90 text-white';
      case 'vault':
        return 'bg-[#1C0118]/90 text-white';
      default:
        return 'bg-black/40 text-white';
    }
  };

  return (
    <SocketProvider token={token}>
      <div className={`min-h-screen flex bg-fixed ${theme} transition-all duration-500`}>
        <CommandPalette />
        <Sidebar />

        <div className={`flex-1 flex flex-col relative ${getModeOverlay()}`}>
          <Navbar />

          {/* Background overlay */}
          <div className="absolute inset-0 pointer-events-none opacity-10 z-0">
            <img
              src={background}
              alt="Decorative Overlay"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Main content */}
          <main className="relative pb-8 overflow-y-auto z-10">{children}</main>
        </div>
      </div>
    </SocketProvider>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
